<template>
  <div class="PASSWORD-RESET-FORM">
    <form class="m-b-4" @submit.prevent="submit">
      <div class="h4 text-bold m-b-1">
        Welcome to Pro Referral
      </div>
      <div class="m-b-4 text-left" >
        Thank you for choosing to register your account.<br/>
        Set a password to manage your project and view, review, or chat with Pros.
      </div>

      <password-fields ref="passwordfields" :disabled="loading"/>

      <special-message ref="error" type="error" class="m-b-2" selenium="reset-password-error">
        Failed to reset password. Please try again later.
      </special-message>

      <div class="text-left m-b-3">
        Password must:
        <ul class="PASSWORD-LIST">
          <li>At least 8 characters long</li>
          <li>Contain both numbers and letters</li>
        </ul>
      </div>

      <button
          :disabled="loading"
          type="submit"
          class="btn w-100"
          selenium="reset-password-button">
        Set Password
      </button>
    </form>
    <div class="m-b-4 text-left" >
      Don't want to set a password?<br/>
      Click the button below to recieve a one time code via email or
      text messsage to access your account.
    </div>
    <button
        :disabled="loading"
        type="button"
        @click.prevent="handleOneTimeCodeClick"
        class="btn-secondary w-100"
        s>
      Sign in with a One-Time Code
    </button>
  </div>
</template>

<script>
import { updateMyPassword } from '@homeservices/api-kit/search/user';
import PasswordFields from '@/components/PasswordFields';
import SpecialMessage from '@/components/SpecialMessage';

export default {
  name: 'tos-password',
  components: {
    PasswordFields,
    SpecialMessage,
  },
  data () {
    return {
      loading: false,
    };
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'homepage' || to.name === 'login') {
      await this.$store.dispatch('user/logoutAndClearUserSession');
    }
    next();
  },
  methods: {
    async submit () {
      this.$refs.error.hide();

      const valid = await this.$refs.passwordfields.$validate();
      if (!valid) { return; }
      try {
        this.loading = true;
        const { data } = await updateMyPassword({
          password: this.$refs.passwordfields.getPassword(),
        });
        await this.$store.dispatch('user/logoutAndClearUserSession');
        await this.$store.dispatch('user/loginUserWithAuthData', data);
        this.$router.push({ name: 'consumer::dashboard' });
      } catch (err) {
        this.$refs.error.trigger(10000);
        this.loading = false;
        throw err;
      } finally {
        this.$refs.passwordfields.reset();
      }
    },
    handleOneTimeCodeClick () {
      this.$events.$emit(this.$events.OTC_LOGIN_PAGE_CLICK);
      this.$router.push({
        name: 'one-time-code', query: { email: this.email, redirectTo: '/' },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .PASSWORD-RESET-FORM {
    text-align: center;
    @include margin(6 auto);
    @include mobile-only () {
      padding: 2 * $unit;
    }
    @include responsive(width, 100%, 630px);
    display: block;
  }
   ul.PASSWORD-LIST {
    list-style-position: inside;
    margin: 0;
    padding:2px;
    font-size: 14px;
  }

</style>
